import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, Calendar, PopupFooter } from '@gem/ui-kit';

import { useDateFieldCalendarPresenter } from './DateFieldCalendar.presenter';
import styles from './DateFieldCalendar.styles.m.css';
import { IDateFieldCalendarProps } from './DateFieldCalendar.types';

export const DateFieldCalendar: FC<ICommonPopupsProps<IDateFieldCalendarProps>> = observer(
  ({ popupInstance, params }) => {
    const { popupClassName, calendarClassName, locale } = params!;
    const presenter = useDateFieldCalendarPresenter({
      popupInstance,
      params,
    });
    const { t } = useTranslation();

    useClosePopupOnNavigation(popupInstance);

    return (
      <Popup
        isOpened
        onClose={presenter.onClose}
        // styles.popupContainer styles.popup нужно для увеличения специфичности селектора, чтобы перекрыть родительские стили
        className={classNames(styles.popup, styles.popupContainer, popupClassName)}
      >
        <div className={styles.container}>
          <Calendar
            value={presenter.selectedDate}
            minDate={presenter.minDate}
            onChange={presenter.onChange}
            className={calendarClassName}
            locale={locale}
          />
        </div>

        <PopupFooter className={styles.footer}>
          <Button
            theme="text-secondary"
            onClick={presenter.onClose}
          >
            {t('common_cancel')}
          </Button>
          <Button
            theme="primary"
            onClick={presenter.onChoose}
          >
            {t('common_apply')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  }
);
